
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 253","d":"M18.147 8.358l-1.015-1.045a.218.218 0 00-.161-.069.209.209 0 00-.161.069l-7.036 7.095-2.56-2.563a.223.223 0 00-.323 0l-1.03 1.027a.23.23 0 000 .329l3.233 3.237a1.021 1.021 0 00.675.329 1.07 1.07 0 00.669-.317h.006l7.71-7.758a.247.247 0 00-.007-.334z","fill":"#3c3c3c"}}),_c('path',{attrs:{"data-name":"Path 254","d":"M12 1.615a10.381 10.381 0 11-7.344 3.04A10.316 10.316 0 0112 1.615M12 0a12 12 0 1012 12A12 12 0 0012 0z","fill":"#3c3c3c"}})])
          )
        }
      }
    